// Brand-level constants for CrewZNatioN
export const LOGO_URL = "/logo-crewznation.png?v=4";
export const LOGO_URL_TIGHT = "/logo-crewznation-tight.png?v=1";

export const SOCIAL = {
    instagram: "https://instagram.com/CrewZNatioN",
    youtube: "https://youtube.com/@CrewZNatioN",
    registration: "https://apply.crewznation.com",
};

export const EMAILS = {
    primary: "mszawawi@crewznation.com",
    admin: "admin@crewznation.com",
    secondary: "crewznation@gmail.com",
};

export const PRIMARY_NAV = [
    { to: "/", label: "Home" },
    { to: "/about", label: "CrewZNatioN" },
    { to: "/gathering", label: "THE GATHERING" },
    { to: "/culture", label: "Culture" },
    { to: "/app", label: "CREWZ APP" },
    { to: "/sponsors", label: "Sponsors" },
    { to: "/store", label: "Store" },
    { to: "/contact", label: "Contact" },
];

// Cinematic Pexels imagery — premium automotive, night, luxury — these are stable URLs
export const IMAGES = {
    // Hero: user-provided CrewZNatioN image
    hero: "https://customer-assets.emergentagent.com/job_crew-connect-68/artifacts/o8nteh4a_IMG_6144.JPG",
    heroAlt: "https://images.pexels.com/photos/3802510/pexels-photo-3802510.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=2000",
    aboutCinematic: "https://images.pexels.com/photos/1719648/pexels-photo-1719648.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1800",
    // Gathering uses a different shot now that the sunset crew shot is on the hero
    gatheringCrowd: "https://images.pexels.com/photos/3954420/pexels-photo-3954420.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1800",
    gatheringWide: "https://images.pexels.com/photos/19316780/pexels-photo-19316780.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=2000",
    motorcycle: "https://images.pexels.com/photos/33203558/pexels-photo-33203558.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1800",
    motorcycleAlt: "https://images.pexels.com/photos/2393821/pexels-photo-2393821.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1800",
    detail1: "https://images.pexels.com/photos/1719648/pexels-photo-1719648.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    detail2: "https://images.pexels.com/photos/2127733/pexels-photo-2127733.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    riyadh: "https://images.pexels.com/photos/14706751/pexels-photo-14706751.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=2000",
    cafeMeet: "https://images.pexels.com/photos/1077785/pexels-photo-1077785.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
    sponsorBg: "https://images.pexels.com/photos/3802510/pexels-photo-3802510.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1800",
};
